'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltipIcon = require('reactackle-tooltip-icon');

var _reactackleCore = require('reactackle-core');

var _InfoBoxStyled = require('./styles/InfoBoxStyled');

var _IconOuterStyled = require('./styles/IconOuterStyled');

var _IconInnerStyled = require('./styles/IconInnerStyled');

var _InnerButton = require('./styles/InnerButton');

var _LabelSlidingStyled = require('./styles/LabelSlidingStyled');

var _LabelStyled = require('./styles/LabelStyled');

var _LabelTextStyled = require('./styles/LabelTextStyled');

var _MessageStyled = require('./styles/MessageStyled');

var _CounterStyled = require('./styles/CounterStyled');

var _PrefixStyled = require('./styles/PrefixStyled');

var _PrefixTextStyled = require('./styles/PrefixTextStyled');

var _PostfixStyled = require('./styles/PostfixStyled');

var _PostfixTextStyled = require('./styles/PostfixTextStyled');

var _TextFieldStyled = require('./styles/TextFieldStyled');

var _TextFieldGroupStyled = require('./styles/TextFieldGroupStyled');

var _TextFieldElementStyled = require('./styles/TextFieldElementStyled');

var _TextFieldContentBoxStyled = require('./styles/TextFieldContentBoxStyled');

var _TextFieldRowStyled = require('./styles/TextFieldRowStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

(0, _reactackleCore.registerDefaultComponentTheme)('textfield', _theme2.default);
var propTypes = {
  /**
   * Value of the TextField
   */
  value: _propTypes2.default.string,

  /**
   * Default value of the TextField
   */
  defaultValue: _propTypes2.default.string,

  /**
   * Placeholder of the TextField
   */
  placeholder: _propTypes2.default.string,

  /**
   * Type of the TextField
   */
  type: _propTypes2.default.oneOf(['text', 'number', 'email', 'tel', 'url', 'password']),

  /**
   * If bordered = false, Input will have only bottom border
   */
  bordered: _propTypes2.default.bool,

  /**
   * Full-width Input doesn't have borders
   */
  fullWidth: _propTypes2.default.bool,

  /**
   * If TextField is dense it has smaller paddings
   */
  dense: _propTypes2.default.bool,

  /**
   * If TextField's max symbol amount defined, symbol counter will be revealed
   */
  symbolLimit: _propTypes2.default.number,

  /**
   * Determines whether TextField is disabled
   */
  disabled: _propTypes2.default.bool,

  /**
   * Defines label text
   */
  label: _propTypes2.default.string,

  /**
   * Defines TextField message (help or error text)
   */
  message: _propTypes2.default.string,

  /**
   * If clearingIcon = true, TextField can be cleared by clicking on clearing-icon
   */
  clearingIcon: _propTypes2.default.bool,

  /**
   * Add icon behind TextField (see IconSvg or IconCustom props)
   */
  iconOuter: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  /**
   * Show icon inside TextField's boundaries (see IconSvg or IconCustom props)
   */
  iconInner: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),

  /**
   * Define label position
   */
  labelPosition: _propTypes2.default.oneOf(['top', 'side']),

  /**
   * If slidingLabel = true, label will float to top
   * when parent TextField is focused or filled
   */
  slidingLabel: _propTypes2.default.bool,

  /**
   * Automatically scroll window to the focused input
   */
  scrollOnFocus: _propTypes2.default.bool,

  /**
   * This prop will be passed to inner input element
   */
  autoComplete: _propTypes2.default.string,

  /**
   * Adds tooltip
   */
  tooltip: _propTypes2.default.string,

  /**
   * Defines component's colorScheme
   */
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),

  /**
   * Add prefix text
   */
  prefix: _propTypes2.default.string,

  /**
   * Add postfix text
   */
  postfix: _propTypes2.default.string,

  /**
   * Determines whether to render TextField in textarea mode
   */
  multiline: _propTypes2.default.bool,

  /**
   * Determines max and min row amount, applies only if multiline prop is true
   */
  multilineRows: _propTypes2.default.shape({
    min: _propTypes2.default.number,
    max: _propTypes2.default.number
  }),

  /**
   * Specify type of resizing, only applied in multiline TextField
   */
  resize: _propTypes2.default.oneOf(['none', 'manual', 'auto']),

  /**
   * @ignore
   */
  theme: _propTypes2.default.object,

  /**
   * Determines pattern to test input
   */
  pattern: _propTypes2.default.object,

  /**
   * Determines pattern function to test input
   */
  patternFn: _propTypes2.default.func,

  /**
   * Specify function to call on TextField value change
   */
  onChange: _propTypes2.default.func,

  /**
   * Specify function to call on TextField focus
   */
  onFocus: _propTypes2.default.func,

  /**
   * Specify function to call on onBlur
   */
  onBlur: _propTypes2.default.func,

  /**
   * Specify function to call on pattern error
   */
  onPatternError: _propTypes2.default.func,

  /**
   * Specify function to call on length error
   */
  onLengthError: _propTypes2.default.func,

  /**
   * Specify function to call on TextField click
   */
  onClick: _propTypes2.default.func
};
var defaultProps = {
  value: void 0,
  defaultValue: '',
  placeholder: '',
  type: 'text',
  bordered: false,
  fullWidth: false,
  multiline: false,
  multilineRows: {
    min: 2,
    max: 4
  },
  resize: 'auto',
  dense: false,
  symbolLimit: 0,
  disabled: false,
  label: '',
  message: '',
  clearingIcon: false,
  iconOuter: null,
  iconInner: null,
  labelPosition: 'top',
  slidingLabel: false,
  scrollOnFocus: false,
  autoComplete: 'off',
  tooltip: null,
  colorScheme: 'neutral',
  prefix: '',
  postfix: '',
  theme: {},
  pattern: /.*/,
  patternFn: _reactackleCore.returnTrue,
  onChange: _reactackleCore.noop,
  onFocus: _reactackleCore.noop,
  onBlur: _reactackleCore.noop,
  onPatternError: _reactackleCore.noop,
  onLengthError: _reactackleCore.noop,
  onClick: _reactackleCore.noop
};

var _TextField = function (_Component) {
  _inherits(_TextField, _Component);

  function _TextField(props) {
    _classCallCheck(this, _TextField);

    var _this = _possibleConstructorReturn(this, (_TextField.__proto__ || Object.getPrototypeOf(_TextField)).call(this, props));

    _this.id = _this.constructor.displayName + '_' + _this.constructor.nextId++;
    _this.state = {
      hidden: props.type === 'password' ? true : null,
      value: _this._valueDefined() ? props.value : props.defaultValue,
      focus: false,
      lengthError: false,
      patternError: false
    };
    _this.textFieldComponent = _this._getTextFieldComponentStyled();
    _this._saveRef = _this._saveRef.bind(_this);
    _this._saveRefWrap = _this._saveRefWrap.bind(_this);
    _this._handleHideValue = _this._handleHideValue.bind(_this);
    _this._handleClearValue = _this._handleClearValue.bind(_this);
    _this._handleBlur = _this._handleBlur.bind(_this);
    _this._handleChange = _this._handleChange.bind(_this);
    _this._handleFocus = _this._handleFocus.bind(_this);
    _this._handleClick = _this._handleClick.bind(_this);
    _this._handleChange = _this._handleChange.bind(_this);
    _this.focus = _this.focus.bind(_this);
    _this.getValue = _this.getValue.bind(_this);
    return _this;
  }

  _createClass(_TextField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isTypeChanged = this.props.type !== nextProps.type;
      var isTextFieldChanged = this.props.multiline !== nextProps.multiline;
      var isValueChanged = nextProps.value !== this.props.value;
      var isDefaultValueChanged = nextProps.defaultValue !== this.props.defaultValue;
      if (isValueChanged && this._valueDefined(nextProps)) this.setState({
        value: nextProps.value
      });
      if (isDefaultValueChanged && !this.state.value.length) this.setState({
        value: nextProps.defaultValue
      });
      if (isTypeChanged) this.setState({
        hidden: nextProps.type === 'password' ? true : null
      });
      if (isTextFieldChanged) this.textFieldComponent = this._getTextFieldComponentStyled();
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this._valueDefined() ? this.props.value : this.state.value;
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this._domNodeInput) this._domNodeInput.focus();
      this.setState({
        focus: true
      });
      this.props.onFocus();
    }
  }, {
    key: '_valueDefined',
    value: function _valueDefined() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return !(0, _reactackleCore.isUndef)(source.value);
    }
  }, {
    key: '_getTextFieldComponentStyled',
    value: function _getTextFieldComponentStyled() {
      if (!this.props.multiline) return _TextFieldElementStyled.InputStyled;
      return this.props.resize === 'auto' ? _TextFieldElementStyled.TextareaAutosizeStyled : _TextFieldElementStyled.TextareaStyled;
    }
  }, {
    key: '_parseValue',
    value: function _parseValue(value) {
      return value;
    }
  }, {
    key: '_handleHideValue',
    value: function _handleHideValue() {
      this.setState(function (_ref) {
        var hidden = _ref.hidden;
        return {
          hidden: !hidden
        };
      });
    }
  }, {
    key: '_handleFocus',
    value: function _handleFocus(event) {
      if (this.props.scrollOnFocus && this._domNodeWrap && typeof this._domNodeWrap.scrollIntoView === 'function') this._domNodeWrap.scrollIntoView();
      this.setState({
        focus: true
      });
      this.props.onFocus(event);
    }
  }, {
    key: '_handleBlur',
    value: function _handleBlur(event) {
      this.setState({
        focus: false
      });
      this.props.onBlur(event);
    }
  }, {
    key: '_handleClick',
    value: function _handleClick(event) {
      this.props.onClick(event);
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(event) {
      var value = this._parseValue((event.currentTarget || event.target).value // TODO fix tests
      );

      var lengthError = this.props.symbolLimit > 0 && value.length > this.props.symbolLimit;

      if (lengthError) {
        value = value.slice(0, this.props.symbolLimit);
        this.props.onLengthError();
      }

      var patternError = !(this.props.patternFn(value) && this.props.pattern.test(value));
      if (patternError) this.props.onPatternError();else this.props.onChange({
        value: value
      });
      if (!this._valueDefined()) this.setState({
        value: value
      });
      this.setState({
        lengthError: lengthError,
        patternError: patternError
      });
    }
  }, {
    key: '_saveRefWrap',
    value: function _saveRefWrap(ref) {
      this._domNodeWrap = ref;
    }
  }, {
    key: '_saveRef',
    value: function _saveRef(ref) {
      this._domNodeInput = ref;
    }
  }, {
    key: '_handleClearValue',
    value: function _handleClearValue() {
      this.setState({
        value: '',
        lengthError: false,
        patternError: false
      });
      this.props.onChange({
        value: ''
      });
    }
  }, {
    key: '_renderCounter',
    value: function _renderCounter() {
      if (!this.props.symbolLimit) return null;
      return _react2.default.createElement(_CounterStyled.CounterStyled, {
        error: this.state.lengthError,
        disabled: this.props.disabled,
        focus: this.state.focus
      }, _react2.default.createElement('span', null, this.state.value.length), _react2.default.createElement('span', null, ' / '), _react2.default.createElement('span', null, this.props.symbolLimit));
    }
  }, {
    key: '_renderMessage',
    value: function _renderMessage() {
      if (!this.props.message) return null;
      return _react2.default.createElement(_MessageStyled.MessageStyled, {
        colorScheme: this.props.colorScheme,
        disabled: this.props.disabled,
        focus: this.state.focus
      }, this.props.message);
    }
  }, {
    key: '_renderLowerLine',
    value: function _renderLowerLine() {
      if (!this.props.message && !this.props.symbolLimit) return null;

      var message = this._renderMessage(),
          counter = this._renderCounter();

      return _react2.default.createElement(_InfoBoxStyled.InfoBoxStyled, {
        bordered: this.props.bordered,
        labelPosition: this.props.labelPosition,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        iconOuter: this.props.iconOuter
      }, message, counter);
    }
  }, {
    key: '_renderInnerButton',
    value: function _renderInnerButton() {
      var componentPath = this.props.theme.reactackle.components.textfield;
      var clearingIconElement = componentPath.clearingIconElement;
      var passwordIconElement = this.state.hidden ? componentPath.passwordIconShowElement : componentPath.passwordIconHideElement;

      if (typeof this.state.hidden === 'boolean') {
        return _react2.default.createElement(_InnerButton.InnerButton, {
          disabled: this.props.disabled,
          focus: this.state.focus,
          dense: this.props.dense,
          fullWidth: this.props.fullWidth,
          colorScheme: this.props.colorScheme,
          onClick: this._handleHideValue
        }, passwordIconElement);
      } else if (this.props.clearingIcon) {
        return _react2.default.createElement(_InnerButton.InnerButton, {
          disabled: this.props.disabled,
          focus: this.state.focus,
          dense: this.props.dense,
          fullWidth: this.props.fullWidth,
          colorScheme: this.props.colorScheme,
          onClick: this._handleClearValue
        }, clearingIconElement);
      }

      return null;
    }
  }, {
    key: '_renderIconOuter',
    value: function _renderIconOuter() {
      var iconOuter = this.props.iconOuter;
      if (!iconOuter) return null;
      var iconElement = void 0;

      if (typeof this.props.iconOuter === "function") {
        var IconOuter = this.props.iconOuter;
        iconElement = _react2.default.createElement(IconOuter, null);
      } else {
        iconElement = this.props.iconOuter;
      }

      return _react2.default.createElement(_IconOuterStyled.IconOuterStyled, {
        disabled: this.props.disabled,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        colorScheme: this.props.colorScheme,
        htmlFor: this.id
      }, iconElement);
    }
  }, {
    key: '_renderIconInner',
    value: function _renderIconInner() {
      var iconInner = this.props.iconInner;
      if (!iconInner) return null;
      var iconElement = void 0;

      if (typeof this.props.iconOuter === "function") {
        var IconInner = this.props.iconInner;
        iconElement = _react2.default.createElement(IconInner, null);
      } else {
        iconElement = this.props.iconInner;
      }

      return this.props.iconInner && _react2.default.createElement(_IconInnerStyled.IconInnerStyled, {
        disabled: this.props.disabled,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        colorScheme: this.props.colorScheme
      }, iconElement);
    }
  }, {
    key: '_renderPrefixText',
    value: function _renderPrefixText() {
      if (!this.props.prefix) return null;
      return _react2.default.createElement(_PrefixTextStyled.PrefixTextStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth
      }, _react2.default.createElement('span', null, this.props.prefix));
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel() {
      if (!this.props.label) return null;
      var tooltip = null;
      if (this.props.tooltip) tooltip = _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, {
        text: this.props.tooltip
      });
      var LabelTag = this.props.slidingLabel ? _LabelSlidingStyled.LabelSlidingStyled : _LabelStyled.LabelStyled;
      return _react2.default.createElement(LabelTag, {
        htmlFor: this.id,
        labelPosition: this.props.labelPosition,
        disabled: this.props.disabled,
        focus: this.state.focus,
        filled: !!this.state.value.length,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        colorScheme: this.props.colorScheme,
        iconOuter: this.props.iconOuter,
        bordered: this.props.bordered
      }, _react2.default.createElement(_LabelTextStyled.LabelTextStyled, null, this.props.label), tooltip);
    }
  }, {
    key: '_renderPrefix',
    value: function _renderPrefix() {
      if (!this.props.prefix && !this.props.iconInner) return null;
      return _react2.default.createElement(_PrefixStyled.PrefixStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        htmlFor: this.id
      }, this._renderIconInner(), this._renderPrefixText());
    }
  }, {
    key: '_renderPostfixText',
    value: function _renderPostfixText() {
      return _react2.default.createElement(_PostfixTextStyled.PostfixTextStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth
      }, _react2.default.createElement('span', null, this.props.postfix));
    }
  }, {
    key: '_renderPostfix',
    value: function _renderPostfix() {
      if (!this.props.postfix) return null;

      var postfixText = this._renderPostfixText();

      return _react2.default.createElement(_PostfixStyled.PostfixStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        htmlFor: this.id
      }, postfixText);
    }
  }, {
    key: '_renderTextField',
    value: function _renderTextField(textFieldProps) {
      var TextFieldComponent = this.textFieldComponent;
      var isPasswordUnhidden = textFieldProps.type === 'password' && !this.state.hidden;
      var inputType = isPasswordUnhidden ? 'text' : textFieldProps.type;
      var props = textFieldProps;
      props.type = inputType;

      if (this.props.multiline && this.props.resize !== 'auto') {
        props.rows = this.props.multilineRows.min;
      }

      return _react2.default.createElement(TextFieldComponent, props);
    }
  }, {
    key: 'render',
    value: function render() {
      var _renderTextField2;

      var isTextareaAutosize = this.props.multiline && this.props.resize === 'auto';

      var iconOuter = this._renderIconOuter(),
          prefix = this._renderPrefix(),
          textField = this._renderTextField((_renderTextField2 = {
        resize: this.props.resize
      }, _defineProperty(_renderTextField2, isTextareaAutosize ? 'saveRef' : 'innerRef', this._saveRef), _defineProperty(_renderTextField2, 'id', this.id), _defineProperty(_renderTextField2, 'dense', this.props.dense), _defineProperty(_renderTextField2, 'fullWidth', this.props.fullWidth), _defineProperty(_renderTextField2, 'placeholder', this.props.placeholder), _defineProperty(_renderTextField2, 'bordered', this.props.bordered), _defineProperty(_renderTextField2, 'colorScheme', this.props.colorScheme), _defineProperty(_renderTextField2, 'focus', this.state.focus), _defineProperty(_renderTextField2, 'type', this.props.type), _defineProperty(_renderTextField2, 'value', this.state.value), _defineProperty(_renderTextField2, 'autoComplete', this.props.autoComplete), _defineProperty(_renderTextField2, 'onChange', this._handleChange), _defineProperty(_renderTextField2, 'onFocus', this._handleFocus), _defineProperty(_renderTextField2, 'onBlur', this._handleBlur), _defineProperty(_renderTextField2, 'onClick', this._handleClick), _defineProperty(_renderTextField2, 'maxRows', this.props.multilineRows.max), _defineProperty(_renderTextField2, 'minRows', this.props.multilineRows.min), _defineProperty(_renderTextField2, 'disabled', this.props.disabled), _renderTextField2)),
          postfix = this._renderPostfix(),
          button = this._renderInnerButton(),
          label = this._renderLabel(),
          lowerLine = this._renderLowerLine();

      return _react2.default.createElement(_TextFieldStyled.TextFieldStyled, {
        innerRef: this._saveRefWrap,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth
      }, _react2.default.createElement(_TextFieldContentBoxStyled.TextFieldContentBoxStyled, {
        labelPosition: this.props.labelPosition
      }, label, _react2.default.createElement(_TextFieldRowStyled.TextFieldRowStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth,
        slidingLabel: this.props.slidingLabel
      }, iconOuter, _react2.default.createElement(_TextFieldGroupStyled.TextFieldGroupStyled, {
        disabled: this.props.disabled,
        bordered: this.props.bordered,
        colorScheme: this.props.colorScheme,
        focus: this.state.focus,
        dense: this.props.dense,
        fullWidth: this.props.fullWidth
      }, prefix, textField, button, postfix))), lowerLine);
    }
  }]);

  return _TextField;
}(_react.Component);

_TextField.nextId = 0;
_TextField.propTypes = propTypes;
_TextField.defaultProps = defaultProps;
_TextField.displayName = 'TextField';
var TextField = (0, _reactackleCore.withTheme)(_TextField);
TextField._withoutHOC = _TextField;
exports.default = TextField;